import { Col, Row } from "react-bootstrap";
import { useState, useEffect } from 'react';
import { Button, Input, Table, Form, Popconfirm, Typography, InputNumber, Modal, Empty } from 'antd';
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector, useDispatch } from 'react-redux'
import {
    getObjective, setMemberFail, getMemberFail, setMemberSuccess, getMemberSuccess, getBizID, getStyle, getFile, getFileID, getServices
} from '../../../../libs/todoSlice'
import LoadingComponent from "../../../../lib/LoadingComponent";
import axios from "axios";
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useNavigate, useParams } from 'react-router-dom';
import fontColor from "../../../../lib/fontColor";
import { getModalBeforeSuccessRedux, setModalBeforeSuccessRedux, getModalNoteRedux, setModalNoteRedux, getLoadingRedux, setLoadingRedux, getNoteTXTRedux, setNoteTXTRedux } from "../../../../libs/addFailSlice";
import Address from "../../../../lib/Address";
import { retryPreRegisterItems } from '../../../../lib/callAgainPreRegister';
import { resolveNoteText } from '../../../../lib/errorKeyNote';
import {
  titleEnFromTh,
  titleThFromEn,
} from '../../../../lib/preRegisterConfig';

//function edit table
const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
}) => {
    const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{
                        margin: 0,
                    }}
                    rules={[
                        // {
                        //   required: true,
                        //   message: `Please Input ${title}!`,
                        // },
                    ]}
                >
                    {inputNode}
                </Form.Item>
            ) : (
                children
            )}
        </td>
    );
};
//end function edit table

const AddTeacherFail = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const memberSuccess = useSelector(getMemberSuccess)
    const memberOneFail = useSelector(getMemberFail)
    const file = useSelector(getFile)
    const objective = useSelector(getObjective)
    const services = useSelector(getServices)
    const business_id = useSelector(getBizID)
    const style = useSelector(getStyle)

    const modalbeforeSuccess = useSelector(getModalBeforeSuccessRedux)
    const setModalBeforeSuccess = (action) => {
        dispatch(setModalBeforeSuccessRedux({
            modalbeforeSuccess: action
        }))
    }

    const modalNote = useSelector(getModalNoteRedux)
    const setModalNote = (action) => {
        dispatch(setModalNoteRedux({
            modalNote: action
        }))
    }

    const loading = useSelector(getLoadingRedux)
    const setLoading = (action) => {
        dispatch(setLoadingRedux({
            loading: action
        }))
    }

    const noteTXT = useSelector(getNoteTXTRedux)
    const setNoteTXT = (action) => {
        dispatch(setNoteTXTRedux({
            noteTXT: action
        }))
    }

    const alertManagement = () => {

        let message = `One ID`
        if (objective.includes('CA') || objective.includes('import-excel-rama')) {
            message += ', CA'
        }
        if (objective.includes('เลขที่หนังสือสัญญา')) {
            message += ' และเลขที่หนังสือสัญญา'
        }

        if (objective.includes('edu-student-pre-register')) {
            message = 'ข้อมูล Pre Registration สำหรับ นักเรียน/นักศึกษา'
        }

        if (objective.includes('edu-teacher-pre-register')) {
            message = 'ข้อมูล Pre Registration สำหรับ ครู/อาจารย์'
        }
        if (objective.includes('Pre-register')) {
            message = 'ข้อมูล Pre Registration สำหรับบุคคลากรทางการแพทย์'
        }

        if (memberSuccess.length !== 0) {
            return (
                <>
                    สร้าง {message} แล้ว {memberSuccess.length} รายการ จาก {file.length} รายการ
                </>
            )
        } else {
            return (
                <>
                    ไม่มีการสร้าง {message}
                </>
            )
        }

    }

    const handleRetrySelected = async () => {
      if (stateBtnAgain.length === 0) return;

      setLoading(true);

      const success = [];
      const fail = [];

      try {
        const { successKeys, failKeys } = await retryPreRegisterItems({
          keys: stateBtnAgain,
          memberOneFail,
          objective,
          business_id,
          services,

          onItemStart: (key) => {
            setData((prev) =>
              prev.map((item) => ({
                ...item,
                loading: item.key === key,
              })),
            );
          },

          onItemSuccess: (key, result) => {
            success.push(result);
          },

          onItemFail: (key, result) => {
            fail.push(result);
          },
        });

        const successSummary = [...memberSuccess, ...success];

        const failSummary = member_fail
          .filter((member) => !successKeys.includes(member.request.key))
          .map((member) => {
            const key = member.request.key;

            if (failKeys.includes(key)) {
              const retryFail = fail.find((item) => item.request.key === key);

              if (retryFail) {
                return {
                  request: retryFail.request,
                  response: retryFail.response,
                };
              }
            }

            return member;
          });

        await sendExcelSummary(successSummary, failSummary);

        dispatch(
          setMemberSuccess({
            member_success: successSummary,
          }),
        );

        dispatch(
          setMemberFail({
            member_fail: failSummary,
          }),
        );

        setStateBtnAgain([]);
        setModalBeforeSuccess(true);
      } finally {
        setLoading(false);

        setData((prev) =>
          prev.map((item) => ({
            ...item,
            loading: false,
          })),
        );
      }
    };

    // function show member to fail table
    useEffect(() => {
        

        let prepareData = memberOneFail.map((members, index) => {
            let title_en = members.request.title_en
            if (!members.request.title_en) {
                const title_th_list = ['นาย', 'นาง', 'นางสาว', 'เด็กหญิง', 'เด็กชาย']
                const title_en_list = ['Mr', 'Mrs', 'Miss', 'Miss', 'Master']
                title_en = title_en_list[title_th_list.indexOf(members.request.title_th)]
            }
            return {
                key: members.request.key,
                loading: false,
                index: index,
                id_card_type: members.request.id_card_type,
                cid: members.request.cid,
                tel: members.request.tel,
                email: members.request.email,
                username: members.request.username,
                address: members.request.address,
                sub_district: members.request.sub_district,
                district: members.request.district,
                province: members.request.province,
                zipcode: members.request.zipcode,
                birth_date: members.request.birth_date,
                title_th: members.request.title_th,
                special_title_th: members.request.special_title_th,
                name_th: members.request.name_th,
                middle_name_th: members.request.middle_name_th,
                surname_th: members.request.surname_th,
                title_en: members.request.title_en,
                special_title_eng: members.request.special_title_eng,
                name_eng: members.request.name_eng,
                middle_name_eng: members.request.middle_name_eng,
                surname_eng: members.request.surname_eng,
                nickname_th: members.request.nickname_th,
                nickname_eng: members.request.nickname_eng,
            }
        })
        setData(prepareData)
    }, [memberOneFail])
    // end function show member to fail table
    //function edit table
    const member_fail = useSelector(getMemberFail)
    useEffect(() => {
        setData(member_fail.map((member, index) => {
            return {
                ...member.request,
                index: index + 1,
                loading: false,
            }
        }))
    }, [member_fail]);

    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [editingKey, setEditingKey] = useState('');
    const isEditing = (record) => record.key === editingKey;
    const edit = (record) => {
        form.setFieldsValue({
            index: '',
            contract_no: '',
            title_th: '',
            name_th: '',
            surname_th: '',
            name_eng: '',
            surname_eng: '',
            cid: '',
            address: '',
            // sub_district: '',
            // district: '',
            // province: '',
            // zipcode: '',
            tel: '',
            mobile: '',
            email: '',
            position: '',
            sub_organization: '',
            // organization:'',
            // tax_id:'',
            // maintainer_name_1:'',
            // maintainer_surname_1:'',
            // maintainer_name_2:'',
            // maintainer_surname_2:'',
            // maintainer_email_1:'',
            // maintainer_email_2:'',
            // maintainer_tel_1:'',
            // maintainer_tel_2:'',
            // name: '',
            // age: '',
            ...record,
        });
        setEditingKey(record.key);
    };
    const cancel = () => {
        setEditingKey('');
    };
    const save = async (key, not_set = false) => {
        setStateBtnAgain([])
        try {
            const row = await form.validateFields();
            const newData = [...data];
            const index = newData.findIndex((item) => {
                return key === item.index
            });
            if (index > -1) {
                const item = newData[index];
                newData.splice(index, 1, {
                    ...item,
                    ...row,
                });
                setData(newData);
                dispatch(setMemberFail({
                    member_fail: memberOneFail.map((member, fail_index) => {
                        return {
                            request: fail_index === index ? newData[index] : member.request,
                            response: member.response
                        }
                    })
                }))
                if (!not_set) {
                    setEditingKey('');
                }
            } else {
                newData.push(row);
                setData(newData);
                if (!not_set) {
                    setEditingKey('');
                }
            }
        } catch (errInfo) {
        }
    };
    // function delete
    const handleDelete = (key) => {
        const newData = data.filter((item) => item.key !== key);
        setData(newData);
        dispatch(setMemberFail({
            member_fail: [...newData.map((item) => {
                return {
                    request: item,
                    response: item.response
                }
            })]
        }))
    };
    // end function delete

    const columns = [
        {
            title: 'ลำดับที่',
            dataIndex: 'index',
            width: 100,
            show: true,
            render: (__, _, index) => __,
            // render: (__, _, index) => parseInt(index) + 1,
        },
        {
            title: (<>คำนำหน้า <br />(ภาษาไทย)</>),
            dataIndex: 'title_th',
            width: 150,
            show: true,
            // width: '10%',
            // editable: true,
            render: (_, record, index) => {
                const editable = isEditing(record);
                return editable ? (
                  <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                    <InputLabel id="title_th">คำนำหน้า</InputLabel>
                    <Select
                      value={record.title_th}
                      labelId="title_th"
                      label="คำนำหน้า"
                      onChange={(e) => {
                        const tempData = [...data];
                        const targetIndex = tempData.findIndex(
                          (item) => item.key === record.key,
                        );

                        if (targetIndex !== -1) {
                          tempData[targetIndex].title_th = e.target.value;
                          tempData[targetIndex].title_en = titleEnFromTh(
                            e.target.value,
                          );
                          setData(tempData);
                        }
                      }}
                    >
                      <MenuItem value={"นาย"}>นาย</MenuItem>
                      <MenuItem value={"นางสาว"}>นางสาว</MenuItem>
                      <MenuItem value={"นาง"}>นาง</MenuItem>
                      {objective.includes("edu-student-pre-register") && (
                        <MenuItem value={"เด็กชาย"}>เด็กชาย</MenuItem>
                      )}
                      {objective.includes("edu-student-pre-register") && (
                        <MenuItem value={"เด็กหญิง"}>เด็กหญิง</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                ) : (
                  record.title_th
                );
            }
        },
        {
            title: (<>คำนำหน้า <br />(ภาษาอังกฤษ)</>),
            dataIndex: 'title_en',
            width: 150,
            show: true,
            // width: '10%',
            // editable: true,
            render: (_, record, index) => {
                let show = ''
                if (!_) {
                    const title_th_list = ['นาย', 'นาง', 'นางสาว', 'เด็กหญิง', 'เด็กชาย']
                    const title_en_list = ['Mr', 'Mrs', 'Miss', 'Miss', 'Master']
                    const title_en = title_en_list[title_th_list.indexOf(record.title_th)]
                    show = title_en
                } else {
                    show = _
                }
                const editable = isEditing(record);
                return editable ? (
                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <InputLabel id="title_en">คำนำหน้า (ภาษาอังกฤษ)</InputLabel>
                        <Select
                            value={show}
                            labelId='title_en'
                            label="ภาษาอังกฤษ"
                            onChange={(e) => {
                                const tempData = [...data];
                                const targetIndex = tempData.findIndex((item) => item.key === record.key);

                                if (targetIndex !== -1) {
                                    tempData[targetIndex].title_en = e.target.value;
                                    tempData[targetIndex].title_th = titleThFromEn(e.target.value);
                                    setData(tempData);
                                }
                                }}
                        >
                            <MenuItem value={'Mr'}>Mr</MenuItem>
                            <MenuItem value={'Miss'}>Miss</MenuItem>
                            <MenuItem value={'Mrs'}>Mrs</MenuItem>
                            {
                                objective.includes('edu-student-pre-register') && (
                                    <MenuItem value={'Master'}>Master</MenuItem>
                                )
                            }
                        </Select>
                    </FormControl>
                ) : (show)
            }
        },
        {
            title: (<>คำนำหน้าอื่นๆ <br />(ภาษาไทย)</>),
            dataIndex: 'special_title_th',
            width: 150,
            show: objective.includes('edu-teacher-pre-register') || objective.includes('edu-student-pre-register'),
            // width: '10%',
            editable: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: (<>คำนำหน้าอื่นๆ <br />(ภาษาอังกฤษ)</>),
            dataIndex: 'special_title_eng',
            width: 150,
            show: objective.includes('edu-teacher-pre-register') || objective.includes('edu-student-pre-register'),
            // width: '10%',
            editable: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: (<>ชื่อ <br />(ภาษาไทย)</>),
            dataIndex: 'name_th',
            width: 150,
            show: true,
            // width: '10%',
            editable: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: (<>นามสกุล <br />(ภาษาไทย)</>),
            dataIndex: 'surname_th',
            width: 150,
            show: true,
            // width: '10%',
            editable: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: (<>ชื่อ <br />(ภาษาอังกฤษ)</>),
            dataIndex: 'name_eng',
            width: 150,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: (<>นามสกุล <br />(ภาษาอังกฤษ)</>),
            dataIndex: 'surname_eng',
            width: 150,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: 'ฉายา (ภาษาไทย)',
            dataIndex: 'nickname_th',
            width: 150,
            editable: true,
            show: objective.includes('edu-teacher-pre-register'),
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: 'ฉายา (ภาษาอังกฤษ)',
            dataIndex: 'nickname_eng',
            width: 150,
            editable: true,
            show: objective.includes('edu-teacher-pre-register'),
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: 'ประเภทบัตร',
            dataIndex: 'id_card_type',
            width: 180,
            show: objective.includes('edu-student-pre-register') || objective.includes('edu-teacher-pre-register'),
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <InputLabel id="id_card_type">ประเภทบัตร</InputLabel>
                        <Select
                            value={record.id_card_type}
                            labelId='id_card_type'
                            label="ประเภทบัตร"
                            onChange={(e) => {
                                record.id_card_type = e.target.value;
                                save(record.index, true)
                            }}
                        >
                            <MenuItem value={'ID_CARD'}>ID_CARD</MenuItem>
                            <MenuItem value={'PASSPORT'}>PASSPORT</MenuItem>
                        </Select>
                    </FormControl>
                ) : (record.id_card_type)
            }
        },
        {
            title: 'เลขประจำตัวประชาชน',
            dataIndex: 'cid',
            width: 150,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: 'username',
            dataIndex: 'username',
            width: 150,
            editable: true,
            // show: objective.includes('edu-student-pre-register'),
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: 'password',
            dataIndex: 'password',
            width: 150,
            editable: true,
            // show: objective.includes('edu-student-pre-register'),
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: 'ที่อยู่',
            dataIndex: 'address',
            width: 400,
            editable: true,
            show: objective.includes('edu-teacher-pre-register'),
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: 'ตำบล',
            dataIndex: 'sub_district',
            width: 150,
            show: objective.includes('edu-teacher-pre-register'),
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_, record, index) => {
                const editable = isEditing(record);
                return editable ? (
                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <InputLabel id="sub_district">ตำบล</InputLabel>
                        <Select
                            value={record.sub_district}
                            labelId='sub_district'
                            label="ตำบล"
                            onChange={(e) => {
                                let tempData = [...data]
                                let index = null
                                tempData.map((d, i) => {
                                    if (d.index === record.index) {
                                        index = i
                                    }
                                    return d
                                })
                                tempData[record.index - 1].sub_district = e.target.value
                                setData(tempData)
                            }}
                        >
                            {Address.getSubDistrict(record.province, record.district).map((sub_district, key) => {
                                return <MenuItem key={key} value={sub_district}>{sub_district}</MenuItem>
                            })}
                        </Select>
                    </FormControl>
                ) : (record.sub_district)
            }
        },
        {
            title: 'อำเภอ',
            dataIndex: 'district',
            width: 150,
            show: objective.includes('edu-teacher-pre-register'),
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_, record, index) => {
                const editable = isEditing(record);
                return editable ? (
                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <InputLabel id="district">อำเภอ</InputLabel>
                        <Select
                            value={record.district}
                            labelId='district'
                            label="อำเภอ"
                            onChange={(e) => {
                                let tempData = [...data]
                                let index = null
                                tempData.map((d, i) => {
                                    if (d.index === record.index) {
                                        index = i
                                    }
                                    return d
                                })
                                tempData[record.index - 1].district = e.target.value
                                setData(tempData)
                            }}
                        >
                            {Address.getDistrict(record.province).map((district, key) => {
                                return <MenuItem key={key} value={district}>{district}</MenuItem>
                            })}
                        </Select>
                    </FormControl>
                ) : (record.district)
            }
        },
        {
            title: 'จังหวัด',
            dataIndex: 'province',
            width: 150,
            show: objective.includes('edu-teacher-pre-register'),
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_, record, index) => {
                const editable = isEditing(record);
                return editable ? (
                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <InputLabel id="id_card_type">จังหวัด</InputLabel>
                        <Select
                            value={record.province}
                            labelId='province'
                            label="จังหวัด"
                            onChange={(e) => {
                                let tempData = [...data]
                                let index = null
                                tempData.map((d, i) => {
                                    if (d.index === record.index) {
                                        index = i
                                    }
                                    return d
                                })
                                tempData[record.index - 1].province = e.target.value
                                setData(tempData)
                            }}
                        >
                            {Address.getProvince().map((province, key) => {
                                return <MenuItem key={key} value={province}>{province}</MenuItem>
                            })}
                        </Select>
                    </FormControl>
                ) : (record.province)
            }
        },
        {
            title: 'รหัสไปรษณีย์',
            dataIndex: 'zipcode',
            width: 150,
            show: objective.includes('edu-teacher-pre-register'),
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_, record, index) => {
                const editable = isEditing(record);
                return editable ? (
                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <InputLabel id="zipcode">รหัสไปรษณีย์</InputLabel>
                        <Select
                            value={record.zipcode}
                            labelId='zipcode'
                            label="รหัสไปรษณีย์"
                            onChange={(e) => {
                                let tempData = [...data]
                                let index = null
                                tempData.map((d, i) => {
                                    if (d.index === record.index) {
                                        index = i
                                    }
                                    return d
                                })
                                tempData[record.index - 1].zipcode = e.target.value
                                setData(tempData)
                            }}
                        >
                            {Address.getZipCode(record.province, record.district, record.sub_district).map((zipcode, key) => {
                                return <MenuItem key={key} value={zipcode}>{zipcode}</MenuItem>
                            })}
                        </Select>
                    </FormControl>
                ) : (record.zipcode)
            }
        },
        {
            title: 'โทรศัพท์',
            dataIndex: 'tel',
            width: 150,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: 'อีเมล',
            dataIndex: 'email',
            width: 250,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: 'operation',
            dataIndex: 'operation',
            show: true,
            fixed: 'right',
            width: 200,
            render: (_, record, index) => {
                const editable = isEditing(record);
                return record.loading ? (
                  <LoadingComponent width={80} height={80} />
                ) : editable ? (
                  <span>
                    <Button
                      type="primary"
                      disabled={loading}
                      onClick={() => save(record.index)}
                      style={{
                        marginRight: 8,
                        background: "#53BE35",
                      }}
                    >
                      บันทึก
                    </Button>
                    <Popconfirm
                      title="Sure to cancel?"
                      disabled={loading}
                      onConfirm={cancel}
                    >
                      ยกเลิก
                    </Popconfirm>
                  </span>
                ) : (
                  <>
                    <Typography.Link
                      disabled={editingKey !== "" || loading}
                      onClick={() => edit(record)}
                    >
                      <ModeEditOutlinedIcon
                        style={{ color: style.primary_color ?? "#053075" }}
                      />
                    </Typography.Link>{" "}
                    &nbsp;
                    {data.length >= 1 ? (
                      <Popconfirm
                        title="ต้องการลบข้อมูลนี้ใช่หรือไม่?"
                        disabled={loading}
                        // disabled
                        onConfirm={() => handleDelete(record.key)}
                      >
                        <DeleteOutlinedIcon
                          style={{ color: "red", cursor: "pointer" }}
                        />
                      </Popconfirm>
                    ) : null}
                    &nbsp;
                    <Button
                      size="large"
                      disabled={loading}
                      style={{ backgroundColor: "#F8F9FA", color: "#053075" }}
                      onClick={() => {
                        setModalNote(true);
                        const message = memberOneFail[index]?.response?.message;
                        setNoteTXT(resolveNoteText(message));
                      }}
                    >
                      หมายเหตุ
                    </Button>
                  </>
                );
            },
        },
    ].filter(head => head.show);
    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: col.dataIndex === 'age' ||
                    col.dataIndex === 'index' ||
                    col.dataIndex === 'no' ? 'number' : 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });
    // end edit table
    // start select row
    const [stateBtnAgain, setStateBtnAgain] = useState([]);
    const rowSelection = {
        selectedRowKeys: stateBtnAgain,
        onChange: (selectedRowKeys, selectedRows) => {
            setStateBtnAgain(selectedRowKeys)
        },
        getCheckboxProps: (selectedRowKeys) => {
            return {
                // Column configuration not to be checked
                key: selectedRowKeys.key,
                disabled: loading
            }
        }
        ,
    };
    // end select row
    // start search top

    // end searct top
    // function add fail or success to history
    const fileID = useSelector(getFileID)
    const params = useParams()
    const sendExcelSummary = async (success, fail) => {
      await axios({
        method: "PATCH",
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/excel`,
        data: {
          _id: fileID,
          total: `${file.length}`,
          success: `${success.length}`,
          fail: `${fail.length}`,
          successDetail: success,
          objective: objective,
          failDetail: fail,
        },
      }).then(
        ({ data, status }) => {},
        ({ response }) => {
          const { status } = response;
          if (status === 401) {
            navigate(`/${params.prefix}`);
          }
        },
      );
    };
    // end add data to history

    const customLocale = {
        emptyText: (<Empty
            description="ไม่มีข้อมูล"
        />)
    };
    return (
      <>
        <Row>
          <Col className="d-flex justify-content-end">
            {stateBtnAgain.length !== 0 && (
              <>
                <Button
                  style={{
                    borderColor: style.secondary_color ?? "#053075",
                    color: "#000000",
                    marginRight: "3px",
                  }}
                  onClick={() => {
                    let prepareData = data.filter(
                      (data) => !stateBtnAgain.includes(data.key),
                    );
                    let prepareDataFail = member_fail.filter(
                      (data) => !stateBtnAgain.includes(data.request.key),
                    );
                    setData(prepareData);
                    dispatch(
                      setMemberFail({
                        member_fail: prepareDataFail,
                      }),
                    );

                    setStateBtnAgain([]);
                  }}
                >
                  ลบ
                </Button>
                <Button
                  type="primary"
                  style={{
                    background: style.secondary_color ?? "#053075",
                    color: style.secondary_color
                      ? fontColor(style.secondary_color)
                      : "#FFFFFF",
                  }}
                  disabled={loading}
                  onClick={handleRetrySelected}
                >
                  <AutorenewIcon /> ดำเนินการสร้างอีกครั้ง
                </Button>
              </>
            )}
          </Col>
        </Row>
        <Row style={{ marginTop: "20px" }}>
          {/* ui table */}
          <Form form={form} component={false}>
            <Table
              locale={customLocale}
              components={{
                body: {
                  cell: EditableCell,
                },
              }}
              bordered
              dataSource={data}
              columns={mergedColumns}
              rowClassName="editable-row"
              pagination={{
                onChange: cancel,
              }}
              scroll={{
                x: 1400,
                y: 400,
              }}
              rowSelection={{
                type: "checkbox",
                // ...rowSelection,
                ...rowSelection,
              }}
            />
          </Form>
          {/* end ui table */}
        </Row>
        {/* modal หมายเหตุ */}
        <Modal
          title="หมายเหตุ"
          centered
          open={modalNote}
          footer={null}
          onCancel={() => setModalNote(false)}
        >
          {noteTXT.map(
            (note, index) =>
              note && (
                <span key={index}>
                  <ul>
                    <li>{JSON.stringify(note).replaceAll('"', "")}</li>
                  </ul>
                </span>
              ),
          )}
        </Modal>
        {/* end modal หมายเหตุ */}
        {/* modal success */}
        <Modal
          title={
            memberSuccess.length !== 0 ? "ทำรายการสำเร็จ" : "ทำรายการไม่สำเร็จ"
          }
          centered
          open={modalbeforeSuccess}
          onOk={() => setModalBeforeSuccess(false)}
          onCancel={() => setModalBeforeSuccess(false)}
          footer={null}
        >
          <Row>
            <Col className="d-flex justify-content-center">
              {memberSuccess.length !== 0 ? (
                <CheckIcon
                  style={{
                    background: "#53BE35",
                    borderRadius: "50%",
                    fontSize: "50px",
                    color: "#fff",
                    padding: "10px",
                  }}
                />
              ) : (
                <CloseIcon
                  style={{
                    background: "#F37959",
                    borderRadius: "50%",
                    fontSize: "50px",
                    color: "#fff",
                    padding: "10px",
                  }}
                />
              )}
            </Col>
          </Row>
          <Row style={{ paddingTop: "30px", paddingBottom: "30px" }}>
            <Col className="d-flex justify-content-center">
              {alertManagement()}
            </Col>
          </Row>
        </Modal>
      </>
    );
}
export default AddTeacherFail